import { AuthClient } from "@anythink-cloud/sdk";
import { config } from "@/config/env";
import { extractOrgIdFromUrl } from "@/utils/hostname";

export const TENANT_ID_KEY = "anythink-last-used-org";

// Create a singleton AuthClient instance
let authClientInstance: AuthClient | null = null;
let activeOrgId: number | null = null;

/**
 * Get the current org ID from URL or localStorage
 */
const getCurrentOrgId = (): number => {
  if (typeof window !== "undefined") {
    // First try URL (highest priority for multi-tab isolation)
    const pathname = window.location.pathname;
    const orgId = extractOrgIdFromUrl(pathname);
    if (orgId) {
      return orgId;
    }

    // Fall back to localStorage (most recent org)
    const storedOrgId = localStorage.getItem(TENANT_ID_KEY);
    if (storedOrgId) {
      const parsedOrgId = Number(storedOrgId);
      if (!isNaN(parsedOrgId)) {
        return parsedOrgId;
      }
    }
  }

  // Default to 0 if nothing found
  return 0;
};

/**
 * Get or create the AuthClient instance
 * For Breeze UI, the orgId is read from URL or localStorage since users can switch orgs
 */
export const getAuthClient = (): AuthClient => {
  const orgId = getCurrentOrgId();

  if (!authClientInstance || activeOrgId !== orgId) {
    activeOrgId = orgId;
    authClientInstance = new AuthClient({
      instanceUrl: config.instanceUrl,
      orgId: orgId,
      storageType: "sessionStorage", // Use sessionStorage to isolate tab credentials
      cookieStorage: {
        name: `anythink_breeze_${orgId}_ui_auth_session`,
      },
    });
  }
  return authClientInstance;
};
